var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "flex-column ai-center" },
    [
      _c("header", { staticClass: "w-5 acenter" }, [
        _c("h1", [_vm._v(_vm._s(_vm.$l10n.__("Identifiez-vous")))]),
        _vm._v(" "),
        _c("p", [
          _vm._v(
            "\n            " +
              _vm._s(
                _vm.$l10n.__(
                  "Afin de compléter la synchronisation de votre compte sur Sellsy, saisissez vos identifiants et mot de passe."
                )
              ) +
              "\n        "
          )
        ])
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-form",
        {
          ref: "form",
          staticClass: "b-1 mt-7 py-4 px-3 w-4 flex-column ai-center relative",
          attrs: { model: _vm.form, rules: _vm.rules }
        },
        [
          _c(
            "icon-svg",
            {
              attrs: {
                "icon-name": _vm.$t.__(
                  "pages.onboarding.email.sync.OnboardingEmailSyncOffice365.office_365"
                ),
                width: 35,
                height: 35
              }
            },
            [_c("icon-office-365")],
            1
          ),
          _vm._v(" "),
          _c("h2", { staticClass: "mt-2 mb-4" }, [
            _vm._v(_vm._s(_vm.$l10n.__("Office 365")))
          ]),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "wp-10",
              attrs: {
                label: _vm.$t.__("common.labels.your_email_address"),
                prop: "email_address",
                error: _vm.errors.get("email_address")
              }
            },
            [
              _c("text-input", {
                attrs: {
                  mode: "edit",
                  readonly: _vm.login_hint ? true : false,
                  value: _vm.form.email_address
                },
                on: { input: _vm.updateLogin }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-form-item",
            {
              staticClass: "wp-10 mb-5",
              attrs: {
                label: _vm.$t.__("common.labels.password"),
                prop: "email_password",
                error: _vm.errors.get("email_password")
              }
            },
            [
              _c("el-input", {
                attrs: {
                  type: "password",
                  "show-password": "",
                  value: _vm.form.email_password
                },
                on: { input: _vm.updatePassword }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "action self-center" },
            [
              _c("CompassButton", {
                staticClass: "self-center",
                attrs: {
                  label: _vm.$t.__(
                    "pages.onboarding.email.sync.OnboardingEmailSyncOffice365.login"
                  ),
                  type: "primary"
                },
                on: {
                  click: function($event) {
                    return _vm.submitForm("form", "signIn")
                  }
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _c("div", [_c("preloader", { attrs: { display: _vm.loading } })], 1)
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass:
          "label label-nobackground danger aleft mt-1 pl-0 formAlert",
        staticStyle: { display: "none" },
        attrs: { id: "email_msg" }
      },
      [_c("span")]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }